import React from "react";
import { IInteriorProductSubGroup, IVec2d } from "../../models/IChainInfo";
import { IInteriorItem } from "../../services/WebApiClient";


export interface InteriorDragContextInfo {
    readonly subGroup: IInteriorProductSubGroup;
    readonly mouseOffset: IVec2d;
    readonly item: IInteriorItem | undefined;
    readonly isDragging: boolean;
    readonly initialCoords: IVec2d;
}

export const InteriorDragContext = React.createContext({
    info: undefined as InteriorDragContextInfo | undefined,
    setInfo: (info: InteriorDragContextInfo | undefined) => { return; }
});


